export const TRANSFER_TARGET_FIELD_NAMES = {
  COMPANY: 'company',
  LEASING_TEAM: 'leasingTeam',
  MANAGER: 'manager',
};

export const NO_AVAILABLE_LEASING_TEAMS = 'No available leasing teams';
export const SELECT_A_LEASING_TEAM = 'Select a leasing team';
export const NO_AVAILABLE_MANAGERS = 'No eligible managers available';
export const SELECT_A_PROPERTY_OWNER = 'Select a new property owner';
